import { motion } from "framer-motion";
import { Globe } from "lucide-react";

const COUNTRIES = [
    {
        name: "South Africa",
        slug: "south-africa",
        text: "English support tailored to the learner's school level and CAPS requirements where applicable.",
    },
    {
        name: "United Kingdom",
        slug: "united-kingdom",
        text: "English support aligned with the relevant school year and curriculum, where appropriate.",
    },
    {
        name: "United States",
        slug: "united-states",
        text: "English support tailored to the child's grade and relevant state or school standards.",
    },
];

export const Countries = () => (
    <section id="countries" className="scroll-mt-24 border-y border-ground-line/60 bg-ground" data-testid="countries-section">
        <div className="mx-auto max-w-7xl px-6 py-20 lg:py-28">
            <motion.div
                className="max-w-2xl"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
            >
                <p className="text-xs font-bold tracking-widest text-sun uppercase">International curriculum support</p>
                <h2 className="font-heading mt-3 text-3xl font-extrabold tracking-tight text-ink sm:text-4xl">
                    English support wherever your child learns
                </h2>
                <p className="mt-4 text-base text-mist sm:text-lg">
                    Lessons follow your child's school level and curriculum, with British or American English
                    conventions used as appropriate.
                </p>
            </motion.div>
            <div className="mt-12 grid gap-6 md:grid-cols-3">
                {COUNTRIES.map((country, i) => (
                    <motion.div
                        key={country.slug}
                        data-testid={`country-card-${country.slug}`}
                        className="rounded-3xl border border-ground-line/70 bg-ground-deep/60 p-8 transition-all duration-300 hover:-translate-y-1 hover:border-sun/50 hover:shadow-xl hover:shadow-black/30"
                        initial={{ opacity: 0, y: 24 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.55, delay: i * 0.12 }}
                    >
                        <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-sun/15 text-sun">
                            <Globe className="h-6 w-6" />
                        </span>
                        <h3 className="font-heading mt-5 text-xl font-bold text-sun">{country.name}</h3>
                        <p className="mt-3 text-sm leading-relaxed text-mist">{country.text}</p>
                    </motion.div>
                ))}
            </div>
            <p className="mt-8 max-w-3xl text-xs leading-relaxed text-mist/70">
                YNova Education is an independent online tutoring service. Lessons support school learning but do not
                claim official accreditation or guaranteed academic results.
            </p>
        </div>
    </section>
);
